import { styled, Typography } from '@mui/material';

export const EmptyStateTitle = styled(Typography)`
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.p040};
  margin-top: 70px;
  margin-bottom: 70px;
  white-space: break-spaces;
`;

export const PostCardsGrid = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white.main};
  padding: 16px 16px 32px 16px;
  gap: 8px;
  margin-top: 40px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1023px) {
    padding-bottom: 48px;
    margin-top: 0px;
    grid-template-columns: 1fr;
  }
`;

export const PostCardWrapper = styled('div')`
  overflow: hidden;

  /* Force PostW (Container > PostW) to fill the column width */
  & > div > div {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 0 !important;
    box-sizing: border-box;
  }
`;

export const SeeAllLink = styled(Typography)`
  position: absolute;
  right: 8px;
  bottom: 8px;
  font-size: 14px;
  text-align: right;
  margin-top: 12px;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 1023px) {
    position: relative;
  }
`;

export const ContainerW = styled('div')`
  width: 100%;
  position: relative;
  border-radius: 15px;
  backgroundcolor: #fbfbfb;
`;

export const PageHeaderW = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PageTitle = styled(Typography)`
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.primary.main};

  @media (max-width: 1023px) {
    display: none;
  }
`;
